<template>
  <div class="card shadow h-100 py-2" :style="cardStyle">
    <div class="card-body">
      <div class="row no-gutters align-items-center">
        <div title="" class="col mr-2">
          <div
            class="text-xs font-weight-bold text-uppercase mb-1"
            :style="textStyle"
          >
            {{ this.title }}
          </div>
          <div class="h5 mb-0 font-weight-bold text-gray-100">
            {{ this.sub_title }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Card",
  props: {
    title: {
      type: String,
    },
    sub_title: {
      type: String,
    },
    border_location: {
      type: String,
      default: "left",
    },
    color: {
      type: String,
    },
    border_color: {
      type: String,
    },
  },
  computed: {
    textStyle() {
      return {
        color: `${this.color} !important`,
        textDecoration: "underline",
        textUnderlinePosition: "under",
        textDecorationStyle: "dotted",
      };
    },
    cardStyle() {
      if (this.border_location == "left") {
        return {
          borderLeft: `0.25rem solid ${this.border_color} !important`,
          backgroundColor: "#313144",
        };
      } else if (this.border_location == "right") {
        return {
          borderRight: `0.25rem solid ${this.border_color} !important`,
        };
      } else if (this.border_location == "top") {
        return {
          borderTop: `0.25rem solid ${this.border_color} !important`,
          backgroundColor: "#000000",
        };
      } else if (this.border_location == "bottom") {
        return {
          borderBottom: `0.25rem solid ${this.border_color} !important`,
          backgroundColor: "#000000",
        };
      } else {
        return {
          borderLeft: `0.25rem solid ${this.color} !important`,
          backgroundColor: "#FFF",
        };
      }
    },
  },
};
</script>

<style scoped>
.card {
  border-radius: 12px;
  box-shadow: 0 6px 10px -4px rgb(0 0 0 / 15%);
  /* background-color: #ffffff; */
  /* background-color: #E8E9F4; */
  /* background-color: #343441; */
  /* background-color: #3C3B3D; */
  background-color: #111827;
  color: #ffffff;
  margin-bottom: 20px;
  position: relative;
  border: 0 none;
  -webkit-transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1),
    box-shadow 200ms ease;
  -moz-transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1),
    box-shadow 200ms ease;
  -o-transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1),
    box-shadow 200ms ease;
  -ms-transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1),
    box-shadow 200ms ease;
  transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1),
    box-shadow 200ms ease;
}

.card:not(.card-plain):hover {
  box-shadow: rgba(0, 0, 0, 0.3) 0px 12px 19px -7px;
  transform: unset;
}

.card .card-body {
  padding: 20px;
}

.mr-2,
.mx-2 {
  margin-right: 0.5rem !important;
}

.card-body {
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 1.25rem;
}

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.h-100 {
  height: 100% !important;
}

.pt-2,
.py-2 {
  padding-top: 0.5rem !important;
}

.card-col {
  flex: 1 0 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin-right: 10px;
  margin-left: 10px;
  margin-bottom: 10px; */
}

/* .card-col:is(:last-child) {
  margin-right: 0px;
}
.card-col:is(:first-child) {
  margin-left: 0px;
} */

.row {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
}
.no-gutters > .col,
.no-gutters > [class*="col-"] {
  padding-right: 0;
  padding-left: 0;
}
.align-items-center {
  -ms-flex-align: center !important;
  align-items: center !important;
}
.font-weight-bold {
  font-weight: 700 !important;
}
.text-uppercase {
  text-transform: uppercase !important;
}
.mb-1,
.my-1 {
  margin-bottom: 0.25rem !important;
}
.mb-0,
.my-0 {
  margin-bottom: 0 !important;
}

/* .text-gray-100 {
  color: #4d4d4d !important;
} */

.text-xs {
  font-size: 0.7rem;
}
</style>